<div class="wrap">
    <div class="head">
        <div class="ttl">Opciones</div>
        <button mat-icon-button type="button" (click)="close()" aria-label="Cerrar">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="sub">Gestionar opciones para <span class="sub-strong">{{ productName }}</span>:</div>

    <div *ngIf="loading" class="state">Cargando...</div>

    <div *ngIf="!loading" class="list-container">
        <!-- Headers -->
        <div class="headers">
            <div class="header-col name-col">Nombre</div>
            <div class="header-col delta-col">Delta precio</div>
            <div class="header-col actions-col"></div>
        </div>

        <!-- Existing Options -->
        <div class="list">
            <div *ngFor="let opt of options; let i = index" class="row">
                <div class="col name-col">
                    <input type="text" class="input-field" [(ngModel)]="opt.name" placeholder="Nombre de la opción"
                        [disabled]="saving" />
                </div>
                <div class="col delta-col">
                    <input type="number" class="input-field" [(ngModel)]="opt.priceDelta" placeholder="0"
                        [disabled]="saving" [step]="0.01" [min]="0" />
                </div>
                <div class="col actions-col">
                    <button mat-icon-button type="button" (click)="removeOption(i)" [disabled]="saving"
                        class="delete-btn">
                        <mat-icon>delete</mat-icon>
                    </button>
                </div>
            </div>

            <!-- New Option Row -->
            <div class="row new-row">
                <div class="col name-col">
                    <input type="text" class="input-field" [(ngModel)]="newOptionName" placeholder="Nombre"
                        [disabled]="saving" />
                </div>
                <div class="col delta-col">
                    <input type="number" class="input-field" [(ngModel)]="newOptionPriceDelta" placeholder="0"
                        [disabled]="saving" [step]="0.01" [min]="0" />
                </div>
                <div class="col actions-col">
                    <button mat-icon-button type="button" color="primary" (click)="addOption()"
                        [disabled]="saving || !newOptionName.trim()" class="add-btn">
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="actions">
        <button mat-stroked-button type="button" (click)="reset()" [disabled]="saving || !hasChanges()">
            <mat-icon>undo</mat-icon>
            Revertir
        </button>
        <button mat-flat-button color="primary" type="button" (click)="save()" [disabled]="saving || !hasChanges()">
            <mat-icon>save</mat-icon>
            Guardar
        </button>
    </div>
</div>